// extracted by mini-css-extract-plugin
export var linkContainer = "plan-site-module--link-container--d210e";
export var linksTitle = "plan-site-module--links-title--79b19";